import { each } from "lodash";
import app from '../angular_app.es6';

app.factory('PasteTableService', [ () => {
  return {
    extract: ($e) => {
      const text = $e.originalEvent.clipboardData.getData('text/plain');

      const lines = text.replace(/\r/g, '').replace(/\n$/, '').split("\n");
      if (lines.length === 1 && lines[0].indexOf("\t") === -1) {
        return null;
      }
      $e.preventDefault();
      return lines;
    },

    apply: (fromIndex, objs, fields, lines, destination, max, exampleFunc) =>{
      each(lines, (line, li) => {
        const words = line.split("\t");
        const correctedLi = li + fromIndex;

        if (correctedLi < objs.length) {
          each(fields, (field, fi) => {
            if (words.length > fi) {
              objs[correctedLi][field] = words[fi].trim();
            }
          });
        }

        if (!!destination && correctedLi >= objs.length && correctedLi < max) {
          const newObj = exampleFunc();
          each(fields, (field, fi) => {
            if (words.length > fi) {
              newObj[field] = words[fi].trim();
            }
          });
          destination.push(newObj);
        }
      });
    }
  };
} ]);
